import React, { useState, useEffect } from "react";
import { Image, Col, Row, Button, Form } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Switch from "react-switch";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import {
  getRestaurantOfferDetailFromOfferID,
  editOfflineOffer,
} from "../../../../../store/actions/SuperAdminActions/adminManageOffers";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import axios from "axios";
import {
  serverApi,
  imageUploadSize,
  videoUploadSize,
} from "../../../../../config/Keys";
import Alert from "react-s-alert";
import isEmpty from "../../../../../store/validation/is-Empty";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import AlertDialogProgress from "../../../../reusableComponents/allPopupReusable/DialogProgression";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

const validationSchema = yup.object({
  name: yup
    .string()
    .required("Offer name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  coupon_code: yup
    .string()
    .required("Coupon code is required")
    .min(1, "Minimum 1 Character")
    .max(16, "Maximum 15 Character"),
  maximum_usage_limit: yup.string().required("Maximum Usage Limit is required"),
  terms_and_condition: yup
    .string()
    .required("Terms and condtion  is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
});

const EditOfflineOffer = (props) => {
  const { offerId } = useParams();
  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.getRestaurantOfferDetailFromOfferID(
      token,
      offerId,
      onSuccessDetailOffer,
      onErrorDetailOffer
    );
  }, []);

  const [editData, setEditData] = useState({});
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState({ active: false });
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const toggleFunction = (e) => {
    setActive({ active: !active.active });
  };

  const onSuccessDetailOffer = (data) => {
    setEditData(data);
  };

  const onErrorDetailOffer = () => {
    setLoading(false);
  };

  const [primaryOffer, setPrimaryOffer] = useState({ primaryOffer: false });
  const markAsPrimary = (e) => {
    setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
  };

  const [state, setState] = useState({
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    restaurant_video: [],
    video_url: "",
    progress: 0,
    actionButton: false,
  });

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/

  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = state.restaurant_pictures;
    let restaurant_pictures_temp = state.restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    oldData.push(e);
    setState({
      ...state,
      restaurant_pictures_new: newToUpload,
      restaurant_pictures: oldData,
      actionButton: true,
    });
  };
  const uploadMultipleFiles = (e) => {
    const vendor_id = editData.vendor_id;
    const restaurant_name = editData.restaurant_id.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    var newUploaded = [];
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > imageUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else if (e.target.files.length > 10) {
        alert("You can upload only 10 files");
        return (flag = false);
      } else {
        let allPicures = state.restaurant_pictures;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          newUploaded.push(e.target.files[i]);
          data.append("files", e.target.files[i]);
        }
      }
    }
    if (!flag) {
      setState({
        ...state,
        restaurant_pictures_new: newUploaded,
        combined: combined,
      });
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };
  const multipleResetFile = (indexId) => {
    let allPicures = state.restaurant_pictures;
    let allPicuresObj = allPicures.find((images, index) => index === indexId);
    if (allPicuresObj === 0 || allPicuresObj) {
      allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
      setState({ ...state, allPicures: allPicures, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    const vendor_id = editData.vendor_id;
    const restaurant_name = editData.restaurant_id.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          if (state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    // ?uploadSide=${combined}
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        setState({
          ...state,
          progress: percent,
        });
      };
      axios
        .post(`${serverApi}/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          setState({
            ...state,
            video_url: "",
          });
          setState({
            ...state,
            restaurant_video: newData,
            video_url: res.data,
            actionButton: true,
          });
          Alert.success(`<h4>Offer Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
  };

  const onSuccessEditOffer = () => {
    history.push("/restaurantadminoffers");
  };

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  useEffect(() => {
    if (history.location && history.location.state) {
      setEditData(history.location.state.editData);
    }
  }, [history.location && history.location.state]);

  useEffect(() => {
    if (editData.name) {
      formik.setFieldValue("name", editData.name);
    }
    if (editData.description) {
      formik.setFieldValue("description", editData.description);
    }
    if (editData.coupon_code) {
      formik.setFieldValue("coupon_code", editData.coupon_code);
    }
    if (editData.maximum_usage_limit) {
      formik.setFieldValue("maximum_usage_limit", editData.maximum_usage_limit);
    }
    if (editData.terms_and_condition) {
      formik.setFieldValue("terms_and_condition", editData.terms_and_condition);
    }
    if (editData.refund_and_cancellation) {
      formik.setFieldValue(
        "refund_and_cancellation",
        editData.refund_and_cancellation
      );
    }
    if (editData && editData.photos) {
      setState({
        ...state,
        restaurant_pictures: !isEmpty(editData.photos) ? editData.photos : [],
        video_url: !isEmpty(editData.offerVideo) ? editData.offerVideo : "",
      });
    }
    if (editData.mark_as_primary) {
      setPrimaryOffer({ primaryOffer: editData.mark_as_primary });
    }

    if (editData.start_date) {
      let startD = editData.start_date.split("T")[0];
      formik.setFieldValue(`start_date`, startD);

      let startT = moment(editData.start_date).format("HH:mm");
      formik.setFieldValue(`start_time`, startT);
    }

    if (editData.end_date) {
      let endD = editData.end_date.split("T")[0];
      formik.setFieldValue(`end_date`, endD);
      let endT = moment(editData.end_date).format("HH:mm");

      formik.setFieldValue(`end_time`, endT);
    }

    if (editData.active) {
      setActive({ active: editData.active });
    }
  }, [editData]);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      coupon_code: "",
      photos: [],
      offerVideo: [],
      terms_and_condition: "",
      refund_and_cancellation: "",
      status: "",
      isOnline: false,
      isGlobal: false,
      pointOfEntry: "VENDOR",
    },
    validationSchema,

    onSubmit: (values) => {
      if (props.auth.user.VendorUser._id) {
        var formData = {};
        const startDate = {
          start_date: moment(
            values.start_date + "T" + values.start_time
          ).toISOString(),
        };
        const end_Date = {
          end_date: moment(
            values.end_date + "T" + values.end_time
          ).toISOString(),
        };

        formData.name = values.name;
        formData.description = values.description;
        formData.coupon_code = values.coupon_code;
        formData.start_date = startDate.start_date;
        formData.end_date = end_Date.end_date;
        formData.maximum_usage_limit = values.maximum_usage_limit;
        formData.photos = state.restaurant_pictures;
        formData.offerVideo = state.video_url;
        formData.terms_and_condition = values.terms_and_condition;
        formData.refund_and_cancellation = values.refund_and_cancellation;
        formData.mark_as_primary = primaryOffer.primaryOffer;
        formData.active = active.active;
        formData.send_to_carousel = false;
        formData.isGlobal = values.isGlobal;
        formData.isOnline = values.isOnline;
        formData.pointOfEntry = values.pointOfEntry;
        formData.vendor_id = props.auth.user.VendorUser._id;

        const token = props.auth.user.accessToken;
        const offerId = editData._id;
        // props.vendor_update_offer(formData, offerId, token, onSuccessEditOffer);
        props.editOfflineOffer(
          token,
          offerId,
          formData,
          onSuccessEditOffer,
          onErrorEditOffer
        );
      }
    },
  });

  const onErrorEditOffer = () => {
    setLoading(false);
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik.errors && formik.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endDateElement = document.getElementById("end_date");
      endDateElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endTimeElement = document.getElementById("end_date");
      endTimeElement.focus();
    } else if (formik.errors && formik.errors.coupon_code) {
      let couponCodeElement = document.getElementById("coupon_code");
      couponCodeElement.focus();
    } else if (formik.errors && formik.errors.maximum_usage_limit) {
      let maximum_usage_limitElement = document.getElementById(
        "maximum_usage_limit"
      );
      maximum_usage_limitElement.focus();
    } else if (formik.errors && formik.errors.terms_and_condition) {
      let termAndCondtionsElement = document.getElementById(
        "terms_and_condition"
      );
      termAndCondtionsElement.focus();
    } else if (formik.errors && formik.errors.refund_and_cancellation) {
      let refund_and_cancellationElement = document.getElementById(
        "refund_and_cancellation"
      );
      refund_and_cancellationElement.focus();
    }
  }, [count]);

  return (
    <>
      {props.auth.loader ? <AmealioLoader /> : <></>}
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">Edit Offer</div>
                </div>
                <div className="d-flex">
                  <div className="enIMG75">
                    <Image
                      //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      src={
                        props.restaurantDetailFromOfferId &&
                        props.restaurantDetailFromOfferId.restaurant_id &&
                        props.restaurantDetailFromOfferId.restaurant_id.logo_url
                      }
                      alt="View"
                      title="View"
                      fluid
                      className="w-100 h-100"
                    />
                  </div>
                  <div className="pl-3 row">
                    <Col
                      lg={10}
                      xl={8}
                      className="d-flex flex-column justify-content-between"
                    >
                      <div className="f24-500">
                        {" "}
                        {props.restaurantDetailFromOfferId &&
                          props.restaurantDetailFromOfferId.restaurant_id &&
                          props.restaurantDetailFromOfferId.restaurant_id
                            .restaurant_name}
                      </div>
                      <div className="f14-400">
                        {props.restaurantDetailFromOfferId &&
                          props.restaurantDetailFromOfferId.restaurant_id &&
                          props.restaurantDetailFromOfferId.restaurant_id
                            .restaurant_address}
                      </div>
                    </Col>
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-start">
                  <div className={`enAddOffersOPtion `}>
                    <Image
                      src={require("../../../../../assets/images/UserManagement/offlineActiveOffer.svg")}
                      alt="View"
                      title="View"
                      fluid
                      className="ml-3"
                    />
                    <span className="text-red f12-400 d-block w-100 mb-2">
                      Offline Offers
                    </span>
                    <span className="w-100 f9-400 d-block">
                      (Note: these offers can be only be used in your business
                      location offline)
                    </span>
                  </div>
                </div>
                <hr />
                <Form>
                  <Row className="pt-4">
                    <Col lg={8}>
                      <Form.Group>
                        <TextField
                          id="name"
                          label="Offer Name"
                          type="text"
                          variant="outlined"
                          className="w-100"
                          name="name"
                          onChange={formik.handleChange}
                          value={formik.values.name}
                          onBlur={formik.handleBlur}
                          // isInvalid={formik.errors.name && formik.touched.name}
                        />
                        {formik.errors.name && formik.touched.name ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.name}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Form.Group>
                        <TextField
                          id="description"
                          label="Description"
                          type="text"
                          multiline
                          rows="5"
                          variant="outlined"
                          className="w-100"
                          name="description"
                          onChange={formik.handleChange}
                          value={formik.values.description}
                          onBlur={formik.handleBlur}
                          //onInvalid={formik.errors.email && formik.touched.email}
                          isInvalid={
                            formik.errors.description &&
                            formik.touched.description
                          }
                        />
                        {formik.errors.description &&
                        formik.touched.description ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.description}
                          </div>
                        ) : null}
                      </Form.Group>
                      <Row className="pb-4">
                        <Col lg={6}>
                          <div className="f12-400">
                            (Fill out the details , offers are used offline)
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="d-flex align-items-start">
                            <Switch
                              onChange={markAsPrimary}
                              checked={primaryOffer.primaryOffer}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                            <div className="pl-2">
                              <div className="f12-500 mb-2">
                                Make this Offer Primary
                              </div>
                              <div className="f10-400">
                                (Note you can make only one Offer primary, by
                                making this offer primary it will remove primary
                                from other active offers)
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <hr />
                      <div className="font_20_b py-4">Offer Details</div>
                      <Row className="pb-4 align-items-center">
                        <Col md={3} xl={2}>
                          <TextField
                            id="start_date"
                            label="Start Date"
                            variant="outlined"
                            type="date"
                            className="w-100"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              inputProps: { min: minDate },
                            }}
                            defaultValue={minDate}
                            name="start_date"
                            // onChange={formik.handleChange}
                            onChange={(e) => handleStartDateChange(e)}
                            value={formik.values.start_date}
                            onBlur={formik.handleBlur}
                            //onInvalid={formik.errors.email && formik.touched.email}
                            isInvalid={
                              formik.errors.start_date &&
                              formik.touched.start_date
                            }
                          />
                          {formik.errors.start_date &&
                          formik.touched.start_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.start_date}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2}>
                          <TextField
                            id="start_time"
                            label="Start Time"
                            variant="outlined"
                            type="time"
                            className="w-100"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="start_time"
                            onChange={formik.handleChange}
                            value={formik.values.start_time}
                            onBlur={formik.handleBlur}
                            //onInvalid={formik.errors.email && formik.touched.email}
                            isInvalid={
                              formik.errors.start_time &&
                              formik.touched.start_time
                            }
                          />
                          {formik.errors.start_time &&
                          formik.touched.start_time ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.start_time}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2}>
                          <TextField
                            id="end_date"
                            label="End Date"
                            variant="outlined"
                            type="date"
                            className="w-100"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              inputProps: { min: minEndDate },
                            }}
                            name="end_date"
                            onChange={formik.handleChange}
                            value={formik.values.end_date}
                            onBlur={formik.handleBlur}
                            //onInvalid={formik.errors.email && formik.touched.email}
                            isInvalid={
                              formik.errors.end_date && formik.touched.end_date
                            }
                          />
                          {formik.errors.end_date && formik.touched.end_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.end_date}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={3} xl={2}>
                          <TextField
                            id="end_time"
                            label="End Time"
                            variant="outlined"
                            type="time"
                            className="w-100"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="end_time"
                            onChange={formik.handleChange}
                            value={formik.values.end_time}
                            onBlur={formik.handleBlur}
                            //onInvalid={formik.errors.email && formik.touched.email}
                            isInvalid={
                              formik.errors.end_time && formik.touched.end_time
                            }
                          />
                          {formik.errors.end_time && formik.touched.end_time ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.end_time}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      <Row className="pb-4 align-items-center">
                        <Col md={4} lg={4}>
                          <Form.Group>
                            <TextField
                              id="coupon_code"
                              label="Coupon Code"
                              type="text"
                              variant="outlined"
                              className="w-100"
                              name="coupon_code"
                              onChange={formik.handleChange}
                              value={formik.values.coupon_code}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.errors.coupon_code &&
                                formik.touched.coupon_code
                              }
                            />
                            {formik.errors.coupon_code &&
                            formik.touched.coupon_code ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.coupon_code}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                        <Col md={4} lg={4}>
                          <Form.Group>
                            <TextField
                              id="maximum_usage_limit"
                              label="Maximum Usage Limit"
                              type="number"
                              variant="outlined"
                              className="w-100"
                              name="maximum_usage_limit"
                              onChange={formik.handleChange}
                              value={formik.values.maximum_usage_limit}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                formik.errors.maximum_usage_limit &&
                                formik.touched.maximum_usage_limit
                              }
                            />
                            {formik.errors.maximum_usage_limit &&
                            formik.touched.maximum_usage_limit ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.maximum_usage_limit}
                              </div>
                            ) : null}
                            {/* <NewInputText
                              extraClass="mb-1"
                              name="maximum_usage_limit"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={maxLengthCheck}
                              inputType="number"
                              onKeyDown={InputNumberFunc}
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.maximum_usage_limit}
                              labelText="Maximum Usage Limit"
                              controlClass="maximum_usage_limit"
                            />
                            {formik.errors.maximum_usage_limit &&
                            formik.touched.maximum_usage_limit ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.maximum_usage_limit}
                              </div>
                            ) : null} */}
                          </Form.Group>
                        </Col>
                        <Col md={4} lg={4}>
                          <div className="form-group d-flex align-items-center">
                            <div className="f18-500 mr-2">Status</div>
                            <div className="f12-400 mr-2">
                              {active.active ? "Active" : "Inactive"}
                            </div>
                            <Switch
                              onChange={toggleFunction}
                              checked={active.active}
                              offColor="#EEEEEE"
                              onColor="#EEEEEE"
                              offHandleColor="#212121"
                              onHandleColor="#59F832"
                              handleDiameter={24}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={15}
                              width={41}
                              boxShadow="-2px 0px 5px #0000003B"
                              activeBoxShadow="-2px 0px 5px #0000003B"
                              id="material-switch"
                            />
                          </div>
                        </Col>
                      </Row>
                      <hr />
                      <div className="event-offer-image">
                        <SimpleReactLightbox>
                          <MultipleImageUploadComponent
                            title="Add Photos*"
                            // smallTitle="(You can upload maximum 5 pic per event 700 x 420 pixels)"
                            onChange={uploadMultipleFiles}
                            stateValue={
                              state.restaurant_pictures &&
                              state.restaurant_pictures
                            }
                            newUploaded={
                              state.restaurant_pictures_new
                                ? state.restaurant_pictures_new
                                : []
                            }
                            combined={state.combined}
                            onCompleteUploadMultipleCrop={
                              onCompleteUploadMultipleCrop
                            }
                            removeImage={multipleResetFile}
                            accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                            // loader={state.multipleImageLoader}
                          />
                          <div className="font_12_r c_gray mb-4 d-flex">
                            (You can upload maximum 5 pic per event 700 x 420
                            pixels)
                          </div>
                        </SimpleReactLightbox>
                      </div>
                      <hr />
                      <div className="event-offer-image">
                        <SimpleReactLightbox>
                          <MultipleImageUploadComponent
                            title="Add Video"
                            // smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
                            onChange={uploadMultipleVideoFiles}
                            stateValue={
                              state.video_url === "" ? [] : [state.video_url]
                            }
                            const
                            removeImage={multipleVideoResetFile}
                            accept="video/*"
                            singleUpload={true}
                            videoUpload={true}
                          />
                          <div className="font_12_r c_gray mb-4 d-flex">
                            (You can upload only 1 pic per offer 700 x 420
                            pixels)
                          </div>
                        </SimpleReactLightbox>
                        {!state.progress && state.progress === 0 ? null : (
                          <AlertDialogProgress
                            progress={state.progress}
                            title="Video Uploading..."
                          />
                        )}
                      </div>
                      <Row>
                        <Col lg={8}>
                          <Form.Group className="mb-0">
                            <TextField
                              id="terms_and_condition"
                              label="Terms and Conditions"
                              type="text"
                              multiline
                              rows="5"
                              variant="outlined"
                              className="w-100"
                              name="terms_and_condition"
                              onChange={formik.handleChange}
                              value={formik.values.terms_and_condition}
                              onBlur={formik.handleBlur}
                              //onInvalid={formik.errors.email && formik.touched.email}
                              isInvalid={
                                formik.errors.terms_and_condition &&
                                formik.touched.terms_and_condition
                              }
                            />
                            {formik.errors.terms_and_condition &&
                            formik.touched.terms_and_condition ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.terms_and_condition}
                              </div>
                            ) : null}
                          </Form.Group>
                          <div className="py-2 f12-400">
                            (Fill out the terms and conditions for offers are
                            used offline)
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={8} className="mt-3">
                          <Form.Group>
                            <TextField
                              id="refund_and_cancellation"
                              label="Refund and Cancellation"
                              type="text"
                              multiline
                              rows="5"
                              variant="outlined"
                              className="w-100"
                              name="refund_and_cancellation"
                              onChange={formik.handleChange}
                              value={formik.values.refund_and_cancellation}
                              onBlur={formik.handleBlur}
                              //onInvalid={formik.errors.email && formik.touched.email}
                              isInvalid={
                                formik.errors.refund_and_cancellation &&
                                formik.touched.refund_and_cancellation
                              }
                            />
                            {formik.errors.refund_and_cancellation &&
                            formik.touched.refund_and_cancellation ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.refund_and_cancellation}
                              </div>
                            ) : null}
                          </Form.Group>
                        </Col>
                      </Row>
                      <div className="py-4 d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5 btn150px"
                          onClick={(e) =>
                            history.push("/restaurantadminoffers")
                          }
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5 btn150px"
                          // type="submit"
                          onClick={() => onClickSave()}
                        >
                          Save
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </>
  );
};

EditOfflineOffer.propTypes = {
  auth: PropTypes.object.isRequired,
  getRestaurantOfferDetailFromOfferID: PropTypes.func.isRequired,
  editOfflineOffer: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  restaurantDetailFromOfferId:
    state.superAdminOffers.restaurantDetailFromOfferId,
});

export default connect(mapStateToProps, {
  getRestaurantOfferDetailFromOfferID,
  editOfflineOffer,
})(EditOfflineOffer);
